import {link_area} from './unit_edit_config_public.js'

const config = {
	link_area,
	
	code: [{
		tab: '内容设置',
		content: [{
			label: '控件内容',
			type: 'editor',
			code: 'content'
		}]
	}]
}

export default config;